import {Popups, Sounds} from "../AssetReferences";

export class MicrobeLinkIDs {
    static AndeMia = "AndeMia"
    static George = "George";    
    static ToiBig = "ToiBig"
    static ToiSmall = "ToiSmall"
}

export class AdditionalElementIDs {
    static BacteriaGrowth = "BacteriaGrowth";
    static CrazyDots = "CrazyDots";
    static PurpleSun = "PurpleSun";
    static StretchingCubes = "StretchingCubes"
}

//  Pop up

export class PopupAssets
{
    static MicrobialSexLoops = Popups.MicrobialSexLoops;
    static DecaySim = Popups.DecaySim;
    static ToiVideoComic = Popups.ToiVideoComic;
    static CybershoreMeditations = Popups.CybershoreMeditations;
    
    static Get(id)
    {
        switch (id) {
            case MicrobeLinkIDs.AndeMia: return Popups.MicrobialSexLoops;
            case MicrobeLinkIDs.George: return Popups.DecaySim;
            case MicrobeLinkIDs.ToiBig: return Popups.ToiVideoComic;
            case MicrobeLinkIDs.ToiSmall: return Popups.CybershoreMeditations;
            // default: console.error("PopupAssets: unknown ID given", id)
        }
        return null;
    }
    
}

// offset the end of the line by {x: vw, y: vh}
export class PopupLineOffsetPosition {
    static AndeMia = {
        start: {x: 0, y: 0},
        end: {x: 10, y: 0}
    }
    static George = {
        start: {x: -1, y: -5},
        end: {x: 10, y: 0}
    }
    static ToiBig = {
        start: {x: -3, y: -5},
        end: {x: 10, y: 0}
    }
    static ToiSmall = {
        start: {x: 0, y :0},
        end: {x: 10, y: 0},
    }
    
    static Get(id)
    {
        switch (id) {
            case MicrobeLinkIDs.AndeMia: return PopupLineOffsetPosition.AndeMia;
            case MicrobeLinkIDs.George: return PopupLineOffsetPosition.George;
            case MicrobeLinkIDs.ToiBig: return PopupLineOffsetPosition.ToiBig;
            case MicrobeLinkIDs.ToiSmall: return PopupLineOffsetPosition.ToiSmall;
            default: console.error("PopupLineOffsetPosition: unknown ID given", id)
        }
        return { start: {x: 0, y: 0}, end: {x: 0, y: 0}};
    }
}

export class PopupPositions
{
    static AndeMia = {top: 5, left: 35}
    static George = {top: 25, left: 15}
    static ToiBig = {top: 34, left: 12}
    static ToiSmall = {top: 82, left: 38}
    
    static Get(id) {
        switch (id) {
            case MicrobeLinkIDs.AndeMia: return PopupPositions.AndeMia;
            case MicrobeLinkIDs.George: return PopupPositions.George;
            case MicrobeLinkIDs.ToiBig: return PopupPositions.ToiBig;
            case MicrobeLinkIDs.ToiSmall: return PopupPositions.ToiSmall;
            default: console.error("PopupPositions: unknown ID given", id)
        }
        return {top: 0, left: 0};
    }
}

const defaultSize = 20;
export class PopupSizes {
    static AndeMia = defaultSize;
    static George = defaultSize;
    static ToiBig = defaultSize;
    static ToiSmall = defaultSize;

    static Get(id) {
        switch (id) {
            case MicrobeLinkIDs.AndeMia: return PopupSizes.AndeMia;
            case MicrobeLinkIDs.George: return PopupSizes.George;
            case MicrobeLinkIDs.ToiBig: return PopupSizes.ToiBig;
            case MicrobeLinkIDs.ToiSmall: return PopupSizes.ToiSmall;
            default: console.error("PopupSizes: unknown ID given", id)
        }
        return defaultSize;
    }
}

export class PopupAlts {
    static AndeMia = "popup title for Microbial Sex Loops project";
    static George = "popup title for Decay Sim project";
    static ToiBig = "popup title for Microbial Sex Loops Video Comic project";
    static ToiSmall = "popup title for Cybershore Meditations project";

    static Get(id) {
        switch (id) {
            case MicrobeLinkIDs.AndeMia: return PopupAlts.AndeMia;
            case MicrobeLinkIDs.George: return PopupAlts.George;
            case MicrobeLinkIDs.ToiBig: return PopupAlts.ToiBig;
            case MicrobeLinkIDs.ToiSmall: return PopupAlts.ToiSmall;
            default: console.error("PopupAlts: unknown ID given", id)
        }
        return "popup title";
    }
}

export class AdditionalElementSounds {
    static BacteriaGrowth = Sounds.BacteriaGrowthFx;
    static CrazyDots = Sounds.CrazyDotsFx;
    static PurpleSun = Sounds.PurpleSunFx;
    static StretchingCubes = Sounds.StretchingCubesFx;

    static Get(id) {
        switch (id) {
            case AdditionalElementIDs.BacteriaGrowth:
                return AdditionalElementSounds.BacteriaGrowth;
            case AdditionalElementIDs.CrazyDots:
                return AdditionalElementSounds.CrazyDots;
            case AdditionalElementIDs.PurpleSun:
                return AdditionalElementSounds.PurpleSun;
            case AdditionalElementIDs.StretchingCubes:
                return AdditionalElementSounds.StretchingCubes;
            default:
                return null;
        }
    }
}